import { render } from "./PlatCostStatistic.vue?vue&type=template&id=87287ac8&scoped=true"
import script from "./PlatCostStatistic.vue?vue&type=script&lang=js"
export * from "./PlatCostStatistic.vue?vue&type=script&lang=js"

import "./PlatCostStatistic.vue?vue&type=style&index=0&id=87287ac8&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87287ac8"]])

export default __exports__